import { Model } from "pinia-orm";
import { QuestionnaireSession, Session, ExaminationDecision, CertipersUser } from "@/models";

export default class UserSession extends Model {
  static entity = "userSessions";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      createdAt: this.string(""),
      role: this.string(""),
      status: this.string(""),
      time: this.string(""),
      isDisplayed: this.boolean(true),
      summonedAt: this.string(),
      // Foreign keys
      userUuid: this.string(""),
      user: this.belongsTo(CertipersUser, "userUuid"),
      sessionUuid: this.string(""),
      sessionData: this.belongsTo(Session, "sessionUuid"),
      questionnaireSession: this.hasOne(QuestionnaireSession, "userSessionUuid"),
      examinationDecisionUuid: this.string(""),
      examinationDecisionData: this.belongsTo(ExaminationDecision, "examinationDecisionUuid"),
    };
  }
}
